import formatterDate from './formatterDate'


const filters = [formatterDate]
export default {
  install: Vue => {
    if (filters.length && filters.length > 0) {
      filters.forEach(item => {
        Vue.filter(item.key, item.func)
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/filters/index.js